var _style, _path, _path2, _path3, _path4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoPdf01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#E0E0E0;}\n\t.st2{fill:#CC4B4C;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1276",
    className: "st0",
    d: "M23.6,0.6H5.5C5,0.6,4.6,1,4.6,1.8v33c0.1,0.4,0.5,0.6,0.9,0.6h24.9c0.4,0,0.8-0.2,0.9-0.6 V8.7c0-0.4-0.1-0.6-0.2-0.7L24,0.7C23.9,0.6,23.7,0.6,23.6,0.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1277",
    className: "st1",
    d: "M23.9,0.7V8h7.4L23.9,0.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1278",
    className: "st2",
    d: "M12.7,21.3L12.7,21.3c-0.2,0-0.4-0.1-0.6-0.2c-0.5-0.3-0.7-0.8-0.7-1.4 c0.1-1,1.4-2.1,3.7-3.2c1-2.2,1.8-4.4,2.4-6.7c-0.6-1.4-1.2-3.1-0.8-4.1c0.1-0.3,0.4-0.6,0.7-0.8c0.2-0.1,0.4-0.1,0.6-0.1 c0.3,0,0.6,0.4,0.8,0.7c0.2,0.2,0.6,0.7-0.2,4.2c0.8,1.7,1.9,3.3,3.2,4.7c0.7-0.1,1.4-0.2,2.1-0.2c1,0,1.6,0.2,1.8,0.7 c0.2,0.5,0.1,1-0.2,1.3c-0.3,0.5-0.8,0.7-1.4,0.7c-0.8,0-1.6-0.5-2.6-1.4c-1.9,0.4-3.7,1-5.5,1.8c-0.4,0.9-0.9,1.8-1.5,2.6 C13.8,20.9,13.3,21.3,12.7,21.3z M14.4,18.1c-1.3,0.7-1.9,1.4-1.9,1.7c0,0.1,0,0.2,0.3,0.4C12.8,20.2,13.4,20,14.4,18.1L14.4,18.1z  M22.9,15.4c0.5,0.4,0.6,0.6,1,0.6c0.3,0,0.6-0.1,0.8-0.3c0.1-0.1,0.1-0.2,0.1-0.3c-0.1,0-0.2-0.1-0.7-0.1 C23.6,15.3,23.2,15.3,22.9,15.4L22.9,15.4z M18.2,11.3c-0.5,1.6-1,3.2-1.7,4.7c1.3-0.5,2.7-0.9,4-1.3C19.7,13.6,18.9,12.5,18.2,11.3 L18.2,11.3z M17.8,6c-0.5,0.6-0.5,1.4,0.1,2C18.5,6.7,17.9,6,17.8,6L17.8,6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1279",
    className: "st2",
    d: "M30.5,35.4H5.5c-0.5,0-0.9-0.4-0.9-0.9c0,0,0,0,0,0v-9.7h26.8v9.7C31.4,35,31,35.4,30.5,35.4 C30.5,35.4,30.5,35.4,30.5,35.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "text",
    transform: "translate(8.287 38.477)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1280",
    className: "st0",
    d: "M3.1-4.9h-1v-6.3h1.8c0.3,0,0.5,0,0.8,0.1c0.3,0.1,0.5,0.2,0.7,0.4c0.2,0.2,0.4,0.4,0.5,0.6 C6-9.8,6.1-9.5,6.1-9.3C6.1-9,6-8.7,5.9-8.4C5.8-8.1,5.7-7.9,5.5-7.7C5.3-7.6,5-7.4,4.8-7.3C4.5-7.2,4.2-7.2,3.9-7.2H3.1L3.1-4.9 L3.1-4.9z M3.1-10.4v2.5H4c0.1,0,0.3,0,0.4-0.1c0.1,0,0.2-0.1,0.3-0.2C4.9-8.3,4.9-8.5,5-8.6C5.1-8.8,5.1-9,5.1-9.3 c0-0.1,0-0.2,0-0.4C5-9.7,5-9.9,4.9-10c-0.1-0.1-0.2-0.2-0.4-0.3c-0.2-0.1-0.4-0.1-0.6-0.1L3.1-10.4L3.1-10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1281",
    className: "st0",
    d: "M12.3-8.2c0,0.4,0,0.9-0.2,1.3c-0.1,0.3-0.2,0.6-0.4,0.9c-0.2,0.2-0.3,0.4-0.6,0.6 c-0.2,0.1-0.4,0.2-0.6,0.3C10.4-5,10.2-5,10-4.9c-0.1,0-0.2,0-0.4,0H7.3v-6.3h1.9c0.5,0,0.9,0.1,1.4,0.3c0.4,0.2,0.7,0.4,1,0.7 c0.3,0.3,0.5,0.6,0.6,0.9C12.3-9,12.3-8.6,12.3-8.2z M9.3-5.7c0.6,0.1,1.1-0.2,1.5-0.7c0.3-0.6,0.5-1.3,0.5-1.9 c0-0.3,0-0.5-0.1-0.8c-0.1-0.3-0.2-0.5-0.4-0.7c-0.2-0.2-0.4-0.4-0.7-0.5c-0.4-0.1-0.8-0.2-1.2-0.2H8.3v4.7L9.3-5.7L9.3-5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1282",
    className: "st0",
    d: "M14.9-10.4v2h2.6v0.7h-2.6v2.8h-1v-6.3h3.9v0.8H14.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPdf01);
export default __webpack_public_path__ + "static/media/ico-pdf-01.9f862691d6a5266bfc9d45e52a8c2751.svg";
export { ForwardRef as ReactComponent };